import React from "react";
import { Modal } from "antd";
import * as S from "./styles";
import DSButton from "../../components/DSButton";
import { AttendanceLimitModalProps } from "./types"; // Importando a tipagem

export function AttendanceLimitModal({ 
  onClose, 
  limit 
}: AttendanceLimitModalProps) {
  return (
    <Modal
      title="Limite de Atendimentos Atingido"
      open
      onCancel={onClose}
      destroyOnClose
      footer={null}
      width={500}
      wrapProps={{ "data-testid": "modal_aviso_limite_atendimentos" }}
    >
      <S.ContentWrapper data-testid="content_aviso_limite_atendimentos">
        <S.Paragraph>
          Você atingiu o limite de <strong>{limit} atendimento(s) simultâneo(s)</strong> permitidos para este emissor.
          <strong> Finalize um atendimento ativo antes de iniciar outro.</strong>
        </S.Paragraph>
      </S.ContentWrapper>

      <S.ButtonsWrapper style={{ justifyContent: "center", marginTop: "1.5rem" }}>
        <DSButton
          type="button"
          buttonText="OK"
          buttonType="secondary"
          onClick={onClose}
          height={30}
          style={{
            padding: "0.4rem 1.5rem",
          }}
          dataTestId="botao_fechar_aviso_limite"
        />
      </S.ButtonsWrapper>
    </Modal>
  );
}